import { BottomSheet } from 'doctornow-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const MentalHealthGuideBottomSheet = ({ isOpen, onClose }: Props) => {
  return (
    <BottomSheet
      type='single'
      title={
        <>
          향정신성의약품, 마약류는
          <br />
          비대면 처방이 어려워요
        </>
      }
      description={
        <>
          향정신성의약품, 마약류, 오남용우려의약품으로
          <br />
          분류된 약품을 제외한 약은 비대면 처방이 가능해요.
        </>
      }
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      buttons={[
        {
          label: '확인했어요',
          variant: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className='flex justify-center'>
        <img
          src='https://media.doctornow.co.kr/web_diagnosis_warning.webp'
          alt='mental health guide'
          className='h-[160px] w-[312px] object-contain'
        />
      </div>
    </BottomSheet>
  );
};

export default MentalHealthGuideBottomSheet;
